/**
 * table
 *    columns 设置width 格式为number类型是可以拖拽列 如width:120
 *    searchType
 *      time 日期选择器 YYYY-MM-DD HH:mm:ss 格式
 *      date 日期选择器 YYYY-MM-DD 格式
 *    pagination 默认为false不展示分页器 可自定义（关闭card actions配置）
 * card
 *    actions 默认分页器 可自定义
 */
import React, { SetStateAction, useEffect, useMemo, useState } from 'react'
import '@minko-fe/use-antd-resizable-header/index.css'
import { Card, CardProps, Pagination, Table } from 'antd'
import styled from 'styled-components'
import { ShowTotal } from '../show-total'
import { ColumnsProps, DraggingTableHeaders } from '../dragging-table-headers'
import Scrollbars from 'react-custom-scrollbars'
import { FilterForm, OptionType } from '../filter-form'
import { useDebounceFn } from 'ahooks'
import { PageLoading } from '../page-loading'
export type Params = {
  page: number
  limit: number
  [k: string]: any
}

interface DraggingTableHeadersProps extends React.ComponentProps<typeof Table> {
  /**参考antd table */
  columns: ColumnsProps
  /**和antd card一样 */
  cardProps?: CardProps
  /**搜索参数 */
  searchParams: Params | any
  /**设置搜索参数 */
  setSearchParams: React.Dispatch<React.SetStateAction<Params | any>>
  /**总数 */
  total: number
  /**表格上面新增元素 */
  tableTop?: React.ReactNode
  /**表格上面新增元素高度 */
  tableTopHeight?: number
  /**多选参数 */
  selectedRowKeys?: string[]
  /**设置多选参数 */
  setSelectedRowKeys: React.Dispatch<SetStateAction<string[]>>
  /**批量操作 */
  batchOperation?: React.ReactNode
  /**搜索项参数 */
  filterOption: OptionType
  /**搜索每列几项 */
  filterRow?: number
  /**整体距上距离 */
  cardTop?: number
  /**是否有侧边（时间选择器占两格） */
  isAside?: boolean
  // 重置事件
  onReset: (d?: any) => void
}
export const ListPage: React.FC<DraggingTableHeadersProps> = ({
  columns,
  dataSource,
  cardProps,
  total = 0,
  searchParams,
  setSearchParams,
  tableTop,
  tableTopHeight = 0,
  selectedRowKeys,
  batchOperation,
  setSelectedRowKeys,
  filterOption,
  filterRow = 4,
  cardTop = 0,
  isAside,
  onReset,
  ...other
}) => {
  const [filterHeight, setFilterHeight] = useState(53)
  const [key, setKey] = useState(0)
  const [filterParams, setFilterParams] = useState<{ [k: string]: string | number | undefined }>()
  const { run } = useDebounceFn(
    d => {
      if (key === 0) setKey(key + 1)
    },
    {
      wait: 500,
    },
  )
  useEffect(() => {
    run(filterOption)
  }, [filterOption])
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardView
        actions={[
          ((!other.pagination && dataSource?.length) || 0) > 0 && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 30 }}>
              <Pagination
                current={searchParams?.page || 0}
                pageSize={searchParams?.limit || 0}
                total={total}
                showTotal={t => <ShowTotal>{t}</ShowTotal>}
                showSizeChanger
                showQuickJumper
                onChange={(page, pageSize) => {
                  setSearchParams(origin => ({ ...origin, page, limit: pageSize as number }))
                }}
              />
            </div>
          ),
        ]}
        {...cardProps}
      >
        <Scrollbars>
          {filterOption && Object.keys(filterOption)?.length > 0 && (
            <FilterForm
              onReset={onReset as any}
              setFilterHeight={setFilterHeight}
              setSearchParams={setSearchParams}
              option={filterOption}
              row={filterRow}
              isAside={isAside}
              setFilterParams={setFilterParams}
              filterParams={{ ...searchParams, ...filterParams }}
            />
          )}
          <div className="main">
            {tableTop && tableTop}
            {key > 0 ? (
              <DraggingTableHeaders
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                total={total}
                key={key}
                selectedRowKeys={selectedRowKeys as string[]}
                setSelectedRowKeys={setSelectedRowKeys}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                batchOperation={batchOperation}
                option={filterOption}
                setFilterParams={setFilterParams}
                filterParams={filterParams}
                scroll={{
                  y: `calc(100vh - 334px ${`- ${filterHeight || 0}px`} ${`- ${
                    (selectedRowKeys || [])?.length > 0 && batchOperation ? 44 : 0
                  }px`} ${`- ${cardTop}px`}`,
                }}
                {...other}
              />
            ) : (
              <PageLoading />
            )}
          </div>
        </Scrollbars>
      </CardView>
    </div>
  )
}

const CardView = styled(Card)`
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  border-radius: 8px;
  overflow: hidden;
  --arh-color: #999;

  .ant-card-body {
    padding: 10px 0 6px !important;
  }
  .main {
    padding: 0 20px;
  }

  .ant-table-filter-trigger:hover {
    background: transparent;
    color: #4238c9;
  }
  .ant-table-filter-column {
    justify-content: flex-start;
    .ant-table-column-title {
      flex: none;
    }
  }
  tr.ant-table-measure-row {
    visibility: collapse;
  }
  .ant-card-body {
    padding: 16px 0 6px;
  }
`
